export const otherBusinessDetailsSelector = (state) => ({
  fields: state.form?.forgivenessPage5?.fields,
  values: state.form?.forgivenessPage5?.values,
  syncErrors: state.form?.forgivenessPage5?.syncErrors,
  preferredCoveredPeriod: state.form?.forgivenessPage1?.values?.preferredCoveredPeriod,
  standardCoveredPeriodStartDate: state.form?.forgivenessPage1?.values?.standardCoveredPeriodStartDate,
  standardCoveredPeriodEndDate: state.form?.forgivenessPage1?.values?.standardCoveredPeriodEndDate,
});
